export enum SyncType {
    Full = "Full",
    Delta = "Delta"
}
